<template>
  <ul class="hotelCommentList">
    <li
      v-for="(review, index) in reviews"
      :key="'comment_item' + index"
      class="hotelCommentListItem"
    >
      <div class="hotelCommentListLeft">
        <p>{{ review.reviewer }}</p>
        <p>投稿日：{{ review.submittedDate }}</p>
        <p class="fontNo">
          <span>{{ review.rating }}</span> / 5
        </p>
        <p class="logoImage">
          <img
            src="~@ota-frontend/shared-assets/images/hotel_detail/logo_expedia.png"
            alt="Expedia"
          />
        </p>
      </div>
      <div class="showText flexRight">
        <input :id="`showText_${_uid}_${index + 1}`" type="checkbox" />
        <div :ref="`showTextArea${index + 1}`" class="showTextArea">
          {{ review.content }}
        </div>
        <label
          v-if="showToggleButtons[index]"
          :for="`showText_${_uid}_${index + 1}`"
          class="showTextBtn"
        >
          <tk-svg-icon icon="down" class="icoMore" />
        </label>
      </div>
    </li>
  </ul>
</template>

<script>
import { TkSvgIcon } from '@ota-frontend/ui'

export default {
  name: 'TkHotelReviewList',
  components: { TkSvgIcon },
  props: {
    reviews: { type: Array, default: () => [] },
  },
  data: function() {
    return {
      showToggleButtons: [...Array(this.reviews.length)].map((i) => true),
    }
  },
  watch: {
    reviews(value) {
      this.$nextTick(() => {
        this.updateToggleButtonVisibility()
      })
    },
  },
  mounted: function() {
    this.updateToggleButtonVisibility()
  },
  methods: {
    updateToggleButtonVisibility() {
      this.showToggleButtons = [...Array(this.reviews.length)].map(
        (item, index) => {
          const currentRef = this.$refs[`showTextArea${index + 1}`]
          return (
            !currentRef ||
            currentRef[0].scrollHeight > currentRef[0].clientHeight
          )
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/TkHotelReview.scss';
</style>
